export interface FooterSection {
  title: string;
  links: Array<{
    label: string;
    href: string;
    isExternal?: boolean;
  }>;
}

export interface SocialMediaLink {
  name: string;
  href: string;
  icon: string;
}

export interface FooterData {
  sections: FooterSection[];
  socialMedia: SocialMediaLink[];
  contactInfo: {
    emails: string[];
    phones: string[];
    whatsapp?: string;
    address: string;
  };
  copyright: string;
  description: string;
}

export const footerData: FooterData = {
  sections: [
    {
      title: 'Servicios',
      links: [
        { label: 'Control de calidad', href: 'https://liec.com.mx/control-de-calidad/', isExternal: true },
        { label: 'Mecánica de Suelos', href: 'https://liec.com.mx/mecanica-de-suelos/', isExternal: true },
        { label: 'Supervisión de Obra', href: 'https://liec.com.mx/supervision-de-obra/', isExternal: true },
        { label: 'Ingeniería Estructural', href: 'https://liec.com.mx/ingenieria-estructural/', isExternal: true },
        { label: 'Topografía', href: 'https://liec.com.mx/topografia/', isExternal: true },
        { label: 'Arquitectura', href: 'https://liec.com.mx/arquitectura/', isExternal: true },
      ],
    },
    {
      title: 'Empresa',
      links: [
        { label: 'Nosotros', href: '#nosotros' },
        { label: 'Historia', href: '#nosotros/historia' },
        { label: 'Misión y Visión', href: '#nosotros/mision-vision' },
        { label: 'Certificaciones', href: '#certificaciones' },
        { label: 'Proyectos', href: '#proyectos' },
        { label: 'Clientes', href: '#clientes' },
      ],
    },
    {
      title: 'Educación',
      links: [
        { label: 'EDUCALIEC', href: '#educaliec' },
        { label: 'Cursos Disponibles', href: '#educaliec/cursos' },
        { label: 'Calendario', href: '#educaliec/calendario' },
        { label: 'Certificaciones', href: '#educaliec/certificaciones' },
        { label: 'Instructores', href: '#educaliec/instructores' },
      ],
    },
    {
      title: 'Soporte',
      links: [
        { label: 'Contacto', href: '#contacto' },
        { label: 'Cotizar', href: '#cotiza' },
        { label: 'Preguntas Frecuentes', href: '#faq' },
        { label: 'Términos y Condiciones', href: '#terminos', isExternal: true },
        { label: 'Política de Privacidad', href: '#privacidad', isExternal: true },
      ],
    },
  ],
  socialMedia: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/liecsa/',
      icon: 'Facebook',
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/liecsadecv',
      icon: 'LinkedIn',
    },
    {
      name: 'YouTube',
      href: 'https://www.youtube.com/@LIECSADECV',
      icon: 'YouTube',
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/liec_oficial',
      icon: 'Instagram',
    },
    {
      name: 'TikTok',
      href: 'https://www.tiktok.com/@liec_sa',
      icon: 'TikTok',
    },
  ],
  contactInfo: {
    emails: ['contacto@liec.com.mx'],
    phones: ['(55) 2161-4772','(55) 6148-9013' ],
    whatsapp: '5561489013',
    address: 'Cda. Morelos 6, San Antonio Tecómitl, CP. 12100, Milpa Alta, CDMX',
  },
  copyright: '© 2026 LIEC - Laboratorio de Control de Calidad de Materiales. Todos los derechos reservados.',
  description: 'Laboratorio líder en México especializado en control de calidad de materiales, mecánica de suelos, ingeniería estructural y servicios de construcción con más de 30 años de experiencia.',
};

export const footerLocations: Array<{
  name: string;
  city: string;
  phones: string[];
  whatsapp?: string;
  emails?: string[];
}> = [
  {
    name: 'Laboratorio Tapachula',
    city: 'Privada Tulipanes Poniente No. 35, Los Tulipanes, C.P. 30797, Tapachula, Chiapas.',
    phones: ['96 2688-8924',],
    whatsapp: '525585849772',
    emails: ['ccampos@liec.com.mx', 'svazquez@liec.com.mx'],
  },
  {
    name: 'Laboratorio Mérida',
    city: 'Calle 50, No. Ext. 123-Local 1 Zona Dorada II, C.P. 97229, Mérida, Yucatán, México.',
    phones: ['99 9948-6356'],
    whatsapp: '529991755327',
    emails: ['lgarcia@liec.com.mx','mantonio@liec.com.mx'],
  },
  {
    name: 'Laboratorio San Luis Potosí',
    city: 'Homero, No. Ext. 455, No. Int. Bodega 6 El Aguaje, C.P. 78398, San Luis Potosí, San Luis Potosí, México',
    phones: ['44 4802-2172'],
    whatsapp: '524449205239',
    emails: ['achagre@liec.com.mx', 'blimon@liec.com.mx'],
  },
  {
    name: 'Laboratorio Tepotzotlán',
    city: 'Calle Mora #23, esquina con Quetzalcóatl, Pblo. San Mateo Xoloc, C.P. 54600, Tepotzotlán, Estado de México.',
    phones: ['55 6148-9013'],
    whatsapp: '5529914470',
    emails: ['jlopez@liec.com.mx','aramos@liec.com.mx'],
  },
  {
    name: 'Laboratorio Lerma',
    city: 'Primera Cda. de la Merced, No. Ext. 6 El Calvario, C.P. 52006, Lerma, Estado de México.',
    phones: ['72 8688-3216'],
    whatsapp: '527226110926',
    emails: ['vmartinez@liec.com.mx','kpadilla@liec.com.mx'],
  },
  {
    name: 'Laboratorio Monterrey',
    city: 'C. Capitan Diego Rodríguez 2020, Arturo B. de la Garza, 64730, Monterrey, N.L.',
    phones: ['814 3055-5821', '814 3055-5822'], 
    whatsapp: '52812616658',
    emails: ['vgonzalez@liec.com.mx'],
  },
];
